var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg24 = function Svg24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.5 4a1 1 0 0 1 1 1v14a1 1 0 1 1-2 0v-6h-8v6a1 1 0 1 1-2 0V5a1 1 0 0 1 2 0v6h8V5a1 1 0 0 1 1-1M20.5 10a1 1 0 0 1 1 1v8a1 1 0 1 1-2 0v-3h-3a1 1 0 0 1-1-1v-4a1 1 0 1 1 2 0v3h2v-3a1 1 0 0 1 1-1"
  })));
};
export default Svg24;